import { css } from 'emotion';

const containerLoading = css`
  display: flex;
  align-items: center;
  flex-direction: column;
  justify-content: center;
  height: 100vh;
`;

const containerMessage = css`
  display: flex;
  align-items: center;
  justify-content: center;
  margin-top: 16px;
  font-size: 14px;
`;
export default {
  containerLoading,
  containerMessage,
};
